import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import PublicLayout from "@/components/site/PublicLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Quality from "@/pages/Quality";
import Contact from "@/pages/Contact";
import Quote from "@/pages/Quote";
import DocShare from "@/pages/DocShare";
import NotFound from "@/pages/NotFound";
import SignInPage from "@/pages/SignInPage";
import AdminLayout from "@/admin/AdminLayout";
import AdminInquiries from "@/admin/AdminInquiries";
import AdminProducts from "@/admin/AdminProducts";
import AdminDocuments from "@/admin/AdminDocuments";

const ClerkLayout = () => (
  <ClerkAuthProvider>
    <Outlet />
  </ClerkAuthProvider>
);

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/products" element={<Products />} />
              <Route path="/products/:slug" element={<ProductDetail />} />
              <Route path="/quality-compliance" element={<Quality />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/request-quote" element={<Quote />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/d/:token" element={<DocShare />} />
            <Route element={<ClerkLayout />}>
              <Route path="/sign-in/*" element={<SignInPage />} />
              <Route path="/sign-up/*" element={<SignInPage signUp />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminInquiries />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="documents" element={<AdminDocuments />} />
              </Route>
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </HelmetProvider>
  );
}

export default App;
